/**
 * Page Matière — léger : révélations + dock + hero vidéo.
 */
(function () {
  'use strict';

  const root = document.querySelector('.bio-matiere');
  if (!root) return;

  let didInit = false;

  function initFades() {
    const items = root.querySelectorAll('[data-bio-fade]');
    if (!items.length) return;

    if (!('IntersectionObserver' in window)) {
      items.forEach((el) => el.classList.add('is-in'));
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );

    items.forEach((el) => io.observe(el));
  }

  function initHeroVideo() {
    const hero = root.querySelector('.bio-matiere-hero');
    const mediaWrap = hero?.querySelector('[data-bio-hero-media]');
    const video = hero?.querySelector('.bio-matiere-hero__video');
    const toggle = hero?.querySelector('[data-bio-hero-video-toggle]');
    if (!video || !mediaWrap) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const markPlaying = () => mediaWrap.classList.add('is-playing');
    video.addEventListener('playing', markPlaying, { once: true });
    if (video.readyState >= 2) markPlaying();

    if (!toggle) return;

    const syncToggle = () => {
      const paused = video.paused;
      toggle.innerHTML = paused ? '<span aria-hidden="true">▶</span>' : '<span aria-hidden="true">Ⅱ</span>';
      toggle.setAttribute('aria-label', paused ? 'Relancer la vidéo' : 'Mettre la vidéo en pause');
    };

    toggle.addEventListener('click', () => {
      if (video.paused) video.play().catch(() => {});
      else video.pause();
    });
    video.addEventListener('play', syncToggle);
    video.addEventListener('pause', syncToggle);
    syncToggle();
  }

  function initDock() {
    const dock = root.querySelector('[data-bio-matiere-dock]');
    const hero = root.querySelector('.bio-matiere-hero');
    const teaser = root.querySelector('.bio-matiere-teaser');
    const nuancier = document.getElementById('nuancier');
    if (!dock) return;

    const show = () => {
      dock.classList.add('is-visible');
      dock.setAttribute('aria-hidden', 'false');
    };
    const hide = () => {
      dock.classList.remove('is-visible');
      dock.setAttribute('aria-hidden', 'true');
    };

    const update = () => {
      const heroBottom = hero?.getBoundingClientRect().bottom ?? 0;
      const anchor = teaser || nuancier;
      const zone = anchor?.getBoundingClientRect();
      const inAnchor =
        zone && zone.top < window.innerHeight * 0.55 && zone.bottom > window.innerHeight * 0.2;

      if (heroBottom > 100 && !inAnchor) show();
      else hide();
    };

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  }

  function init() {
    if (didInit) return;
    initFades();
    initHeroVideo();
    initDock();
    root.classList.add('is-ready');
    didInit = true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (e) => {
    if (!e.target?.querySelector?.('.bio-matiere')) return;
    didInit = false;
    init();
  });
})();
